import checkObjectType from '../_helpers/checkobjecttype.js';
import { parseHTML, toNodes } from '../_dom/index.js';
import parserData from './_parserdata.js';
import processTextNode from './_processtextnode.js';
import processAttribute from './_processattribute/index.js';
import getNodes from '../bindnode/_getnodes.js';
import forEach from '../_helpers/foreach.js';
import assign from '../_helpers/assign.js';
import toArray from '../_helpers/toarray.js';
var ELEMENT_NODE = 1;
var TEXT_NODE = 3;
export default function parseBindings(object, givenNodes, eventOptions) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    eventOptions = givenNodes;
    givenNodes = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'parseBindings');
  }
  var extendedEventOptions = {
    // useExactBinder is little optimization
    // without this option used binder is extended by default binder
    useExactBinder: true,
    fromParser: true,
    setValueOnBind: true
  };
  if (typeof eventOptions === 'object') {
    assign(extendedEventOptions, eventOptions);
  }
  var nodes;
  // the template holding the nodes of an HTML string
  var htmlContent = null;
  var allNodes = [];
  // extract all needed data from parserData
  // check out what is parserData in its module
  var leftBracket = parserData.leftBracket,
    htmlLeftBrackets = parserData.htmlLeftBrackets,
    bindingReg = parserData.bindingReg;
  var hasBracket = function hasBracket(html) {
    return htmlLeftBrackets.some(function (bracket) {
      return html.indexOf(bracket) !== -1;
    });
  };
  if (typeof givenNodes === 'string') {
    if (~givenNodes.indexOf('<')) {
      var _nodes$0$parentNode, _nodes$;
      // this is HTML
      nodes = parseHTML(givenNodes);
      if (!~givenNodes.indexOf(leftBracket)) {
        // if it doesn't include parser bracket then we don't need to check
        // their existence for all included nodes in cycle below
        return nodes;
      }
      htmlContent = (_nodes$0$parentNode = (_nodes$ = nodes[0]) == null ? void 0 : _nodes$.parentNode) != null ? _nodes$0$parentNode : null;
    } else {
      // this is a selector
      nodes = getNodes(object, givenNodes);
    }
  } else if (typeof givenNodes === 'object') {
    // this is a node, nodeList or something else (eg array, jQuery instance etc)
    nodes = toNodes(givenNodes);
  }
  // to make possible to not use recursion we're collecting all nodes to allNodes array
  // nodes of another kind (a number, undefined) throw here, as before
  forEach(nodes, function (node) {
    return allNodes.push(node);
  });
  // on every cycle of array we're adding new descendants to allNodes
  // increasing # of needed iterations
  var _loop = function _loop() {
      var node = allNodes[i];
      // allow to parse elements only
      if (node.nodeType !== ELEMENT_NODE) {
        return 0; // continue
      }
      var outerHTML = node.outerHTML,
        innerHTML = node.innerHTML,
        childNodes = node.childNodes,
        attributes = node.attributes;
      // if outerHTML does't contain left bracket, then this node doesn't need to be parsed
      if (!hasBracket(outerHTML)) {
        return 0; // continue
      }
      // initialize bindings for attributes if they appear
      if (attributes.length) {
        // fixes Firefox issue: attributes.length can be changed by processAttribute
        var attrs = attributes.length > 1 ? Array.prototype.slice.call(attributes) : attributes;
        forEach(attrs, function (attribute) {
          if (bindingReg.test(attribute.value)) {
            processAttribute({
              node: node,
              attribute: attribute,
              object: object,
              eventOptions: extendedEventOptions
            });
          }
        });
      }
      // if innerHTML does't contain left bracket,
      // then children of this node don't need to be parsed
      if (!hasBracket(innerHTML)) {
        return 0; // continue
      }
      // a copy: processTextNode inserts the bound text nodes, and a value holding "{{y}}" must stay text
      var children = toArray(childNodes);
      for (var j = 0; j < children.length; j++) {
        var childNode = children[j];
        var nodeType = childNode.nodeType,
          textContent = childNode.textContent;
        if (nodeType === ELEMENT_NODE) {
          // if childNode is HTML element then add it to the end of allNodes array
          // to check everything on next outer cycle iterations
          allNodes.push(childNode);
        } else if (nodeType === TEXT_NODE) {
          // if childNode is text node which contains things like {{x}}
          // then initialize bindings for this node
          if (bindingReg.test(textContent)) {
            processTextNode({
              object: object,
              node: node,
              textNode: childNode,
              eventOptions: extendedEventOptions
            });
          }
        }
      }
    },
    _ret;
  for (var i = 0; i < allNodes.length; i++) {
    _ret = _loop();
    if (_ret === 0) continue;
  }
  // a top-level text node of an HTML string ("{{a}} <b>{{b}}</b>") is split up too, so the nodes are read again
  if (htmlContent) {
    forEach(toArray(htmlContent.childNodes), function (textNode) {
      if (textNode.nodeType === TEXT_NODE && bindingReg.test(textNode.textContent)) {
        processTextNode({
          object: object,
          node: htmlContent,
          textNode: textNode,
          eventOptions: extendedEventOptions
        });
      }
    });
    return toArray(htmlContent.childNodes);
  }
  return nodes;
}